import { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Navform from "./components/Navform";
import Alert from "./components/Alert";
// import About from "./components/About";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [mode, setMode] = useState("light");
  const [alert, setalert] = useState(null);

  const showAlert = (message, type) => {
    setalert({
      msg: message,
      type: type,
    });

    setTimeout(() => {
      setalert(null);
    }, 1500);
  };

  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      showAlert("Dark mode has been enable", "success");
    } else {
      setMode("light");
      showAlert("Light mode has been enable", "success");
    }
  };

  return (
    <>
      {/* <Router> */}
        <Navbar mode={mode} toggleMode={toggleMode} />
        <Alert alert={alert} />
        <div className="container">
          {/* <Routes>
            <Route exact path="/about" element={<About/>}>
            </Route> */}
            <Navform
                showAlert={showAlert}
                heading="Enter the text to Analyze"/>
          {/* </Routes> */}
        </div>
      {/* </Router> */}
    </>
  );
}

export default App;
